export interface ITicketData {
  reporter_user: ReporterUser;
  reported_user: ReportedUser;
  ticket_type: ticketType;
  ticket_status: ticketStatus;
  reason: string;
  comment: string;
  ticket_code: string;
  chat_id: string;
  admin_feedback: string | null;
  suspendedUntil?: string | null;
  _id: string;
  createdAt: Date;
  updatedAt: Date;
  book_id: string;
}

export interface ReportedUser {
  user_name: string;
  reported_id: string;
}

export interface ReporterUser {
  reporter_id: string;
  user_name: string;
}

export enum ticketType {
  chat = 'chat',
  user = 'user',
  book = 'book',
  bug = 'bug',
  regular = 'regular',
}

export enum ticketStatus {
  pending = 'pending',
  resolved = 'resolved',
  rejected = 'rejected',
  in_progress = 'in_progress',
}
export interface IChatMessage {
  _id: string;
  senderId: string;
  content: string;
  status: string;
  timestamp: Date;
  sender: Sender;
}

export interface Sender {
  _id: string;
  fullName: string;
}
